import React from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    Typography,
    Divider,
    Box,
    Paper
} from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import HistoryIcon from '@mui/icons-material/History';
import { colors } from '../../../customTheme';

const benefits = [
    {
      icon: <ShareOutlinedIcon sx={{ color: colors.slatePurple }} />,
      title: 'Closet Sharing',
      description: 'Unlimited closet sharing',
    },
    {
      icon: <SearchOutlinedIcon sx={{ color: colors.slatePurple }} />,
      title: 'Product Research',
      description: 'Unlimited searches',
    },
    {
      icon: <HistoryIcon sx={{ color: colors.slatePurple }} />,
      title: 'Historical Data',
      description: 'Unlimited historical Poshmark data',
    },
  ];

const benefitsGrid = (
    <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1.5,
            mt: 3,
            mb: 3,
            mr: 2,
            ml: 2, 
          }}
        >
          {benefits.map((item, idx) => (
            <Paper
              key={idx}
              elevation={1}
              sx={{
                flex: '1 1 250px',
                backgroundColor: '#F4F3FF',
                minWidth: 0,
                borderRadius: 2,
                p: 2.5,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ mb: 1 }}>{item.icon}</Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: colors.slatePurple, mb: 2 }}>
                {item.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: 'gray', mb: 2 }}
              >
                {item.description}
              </Typography>
            </Paper>
        ))}
    </Box>
)

function ConfirmCancellation({ open, onBack, onNext }) {
  return (
    <Dialog open={open} onClose={onBack} maxWidth="md" fullWidth>
      <DialogTitle sx={{ color: "black", pt: 4, pl: 4, fontSize: '24px', fontWeight: '600' }}>Are you sure you want to end your subscription?</DialogTitle>
      <DialogContent sx={{ pl: 4, pb: 4 }}>
        <Typography sx={{ color: 'gray', mt: 1, pb: 2, fontSize: '18px' }}>You will lose access to these benefits:</Typography>
        {benefitsGrid}
      </DialogContent>
      <Divider />
      <DialogActions sx={{ pb: 4, pr: 4, pt: 3 }}>
        <Button onClick={onBack}>Back</Button>
        <Button onClick={() => onNext(true)} variant="contained" color="error">
          Cancel Subscription
        </Button>
      </DialogActions>
    </Dialog>  
  );
}

export default ConfirmCancellation;
